import { IsBoolean, IsDecimal, IsNumberString } from 'class-validator';

export class GiftCardRedemptionResponse {
  constructor(
    cardNumber: string,
    balance: number,
    previousBalance: number,
    amountRedeemed: number,
    success: boolean,
    reference: number
  ) {
    this.cardNumber = cardNumber;
    this.balance = balance;
    this.previousBalance = previousBalance;
    this.amountRedeemed = amountRedeemed;
    this.success = success;
    this.reference = reference;
  }

  cardNumber: string;

  @IsDecimal()
  balance: number;

  @IsDecimal()
  previousBalance: number;

  @IsDecimal()
  amountRedeemed: number;

  @IsBoolean()
  success: boolean;

  @IsDecimal()
  reference: number;
}
